import {store} from './index';
import {Module, VuexModule, Mutation, Action} from 'vuex-module-decorators';
import iNomCateg from '@/types/iNomCateg';
import iNomTipDoc from '@/types/iNomTipDoc';
import iNomRegistru from '@/types/iNomRegistru';
import iLabelValue from '@/types/iLabelValue';


@Module({ namespaced: true, dynamic: true, store, name: 'storeNomenclatoare'})
export default class User extends VuexModule {
  public currentPageTitle:string='';
  public NomCategorii: iNomCateg[] =[];
  public NomTipDoc: iNomTipDoc[] =[];
  public NomRegistre: iNomRegistru[] =[];
  public NomCategSolicitant : iLabelValue[]=[
    {label:'Institutie Publica', value: 'pu'},
    {label:'Persoana Fizica', value: 'pf'},
    {label:'Persoana Juridica', value: 'pj'}
  ]

  public MyImgProfileString64: string = '';

  @Mutation
  public SET_CURRENTPAGETITLE(ptitle: string) {
    this.currentPageTitle = JSON.parse(JSON.stringify(ptitle));
  }
  @Action
  public set_currentpagetitle(ptitle: string) {
    this.context.commit('SET_CURRENTPAGETITLE', ptitle);
  }

  @Mutation
  public SET_NOMCATEGORII(pcategorii: iNomCateg[]) {
    this.NomCategorii = JSON.parse(JSON.stringify(pcategorii));
  }
  @Action
  public set_nomcategorii(pcategorii: iNomCateg[]) {
    this.context.commit('SET_NOMCATEGORII', pcategorii);
  }


  @Mutation
  public SET_NOMTIPDOC(ptipdoc: iNomTipDoc[]) {
    this.NomTipDoc = JSON.parse(JSON.stringify(ptipdoc));
  }
  @Action
  public set_nomtipdoc(ptipdoc: iNomTipDoc[]) {
    this.context.commit('SET_NOMTIPDOC', ptipdoc);
  }


  @Mutation
  public SET_NOMREGISTRE(pregistre: iNomRegistru[]) {
    this.NomRegistre = JSON.parse(JSON.stringify(pregistre));
  }
  @Action
  public set_nomregistre(pregistre: iNomRegistru[]) {
    this.context.commit('SET_NOMREGISTRE', pregistre);
  }
}
